import { render } from "./ActionsTable.vue?vue&type=template&id=63f82e52&scoped=true"
import script from "./ActionsTable.vue?vue&type=script&lang=js"
export * from "./ActionsTable.vue?vue&type=script&lang=js"

import "./ActionsTable.vue?vue&type=style&index=0&id=63f82e52&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f82e52"]])

export default __exports__